// src/pages/JobsInternshipPage.jsx
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

import "./JobsInternshipPage.css";

const API_BASE_URL = process.env.REACT_APP_BACKEND_API_URL;

// Helper to format deadline date
const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

export default function JobsInternshipPage() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${API_BASE_URL}/jobs/active`);

        // Safe fallback in case jobs is undefined
        setJobs(res.data?.jobs || []);
      } catch (err) {
        console.error("Failed to fetch jobs:", err.message);
        setError("We are currently unable to load job listings. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchJobs();
  }, []);

  if (loading) {
    return (
      <div className="jobs-container">
        <p>Loading current opportunities...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="jobs-container jobs-error">
        <p>{error}</p>
      </div>
    );
  }

  return (
    <div className="jobs-container">
      <h1 className="page-title">Jobs & Internships</h1>

      {/* Professional Empty State */}
      {jobs.length === 0 ? (
        <div className="jobs-empty-state">
          <h2>No Active Job Opportunities at the Moment</h2>
          <p>
            There are currently no open positions available.
          </p>
          <p>
            Please check back soon or follow our official channels
            for updates on future job opportunities.
          </p>
        </div>
      ) : (
        <div className="jobs-grid">
          {jobs.map((job) => (
            <div className="job-card" key={job._id}>
              <h2 className="card-title">{job.title}</h2>
              <p className="card-company">{job.company}</p>

              <p className="card-info">{job.location}</p>
              <p className="card-info">{job.type}</p>

              <p className="card-deadline">
                Deadline: <strong>{formatDate(job.deadline)}</strong>
              </p>

              <p className="card-summary">{job.summary}</p>

              <Link to={`/jobs/${job._id}`} className="card-button">
                View More Information
              </Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
